import React, { useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../shared/store';
import { useMerchantAuth } from '../../../contexts/AuthContext';
import { startTutorial, resetTutorial } from '../store/tutorialSlice';
import { AcademicCapIcon } from '@heroicons/react/24/outline';

export default function TutorialButton() {
    const dispatch = useAppDispatch();
    const { loyalpassAdmin } = useMerchantAuth();
    const { isActive, isComplete } = useAppSelector((state) => state.tutorial);
    const [showConfirmModal, setShowConfirmModal] = useState(false);

    if (loyalpassAdmin) {
        return null;
    }

    const handleStartTutorial = () => {
        dispatch(startTutorial());
    };

    const handleRestartClick = () => {
        setShowConfirmModal(true);
    };

    const handleConfirmRestart = () => {
        dispatch(resetTutorial());
        dispatch(startTutorial());
        setShowConfirmModal(false);
    };

    const handleCancelRestart = () => {
        setShowConfirmModal(false);
    };

    if (isActive) {
        return null; // Don't show button when tutorial is active
    }

    return (
        <>
            <button
                onClick={isComplete ? handleRestartClick : handleStartTutorial}
                className="flex items-center gap-2 px-4 py-2 bg-primary text-white rounded-md hover:bg-primary/90 transition text-sm font-medium"
                title={isComplete ? 'Restart Tutorial' : 'Start Tutorial'}
            >
                <AcademicCapIcon className="w-5 h-5" />
                {isComplete ? 'Restart Tutorial' : 'Start Tutorial'}
            </button>

            {/* Confirmation Modal */}
            {showConfirmModal && (
                <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg shadow-lg max-w-md w-full p-6">
                        <h3 className="text-lg font-semibold text-gray-800 mb-4">Restart Tutorial</h3>
                        <p className="text-gray-600 mb-6">
                            Are you sure you want to restart the tutorial? Your current progress will be reset.
                        </p>
                        <div className="flex justify-end space-x-3">
                            <button
                                onClick={handleCancelRestart}
                                className="px-4 py-2 rounded bg-gray-300 hover:bg-gray-400 text-gray-800 transition"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleConfirmRestart}
                                className="px-4 py-2 rounded bg-primary hover:bg-primary/90 text-white transition"
                            >
                                Restart
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

